"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KustoResultTable = exports.KustoResultColumn = exports.KustoResultRow = exports.WellKnownDataSet = void 0;
const moment_1 = __importDefault(require("moment"));
var WellKnownDataSet;
(function (WellKnownDataSet) {
    WellKnownDataSet["PrimaryResult"] = "PrimaryResult";
    WellKnownDataSet["QueryCompletionInformation"] = "QueryCompletionInformation";
    WellKnownDataSet["TableOfContents"] = "TableOfContents";
    WellKnownDataSet["QueryProperties"] = "QueryProperties";
})(WellKnownDataSet = exports.WellKnownDataSet || (exports.WellKnownDataSet = {}));
;
const ValueParser = {
    datetime: moment_1.default,
    timespan: moment_1.default.duration,
    DateTime: moment_1.default,
    TimeSpan: moment_1.default.duration,
};
class KustoResultRow {
    constructor(columns, row) {
        this.columns = columns.sort((a, b) => a.ordinal - b.ordinal);
        this.raw = row;
        for (const col of this.columns) {
            const parse = ValueParser[col.type];
            this[col.name] = parse ? parse(row[col.ordinal]) : row[col.ordinal];
        }
    }
    *values() {
        // tslint:disable-next-line:forin
        for (const item in this.rows) {
            yield item;
        }
    }
    getValueAt(index) {
        return this[this.columns[index].name];
    }
    toJson() {
        const obj = {};
        for (const col of this.columns) {
            obj[col.name] = this[col.name];
        }
        return obj;
    }
    toString() {
        return JSON.stringify(this.toJson());
    }
}
exports.KustoResultRow = KustoResultRow;
class KustoResultColumn {
    constructor(columnObj, ordinal) {
        var _a, _b;
        this.name = (_a = columnObj.ColumnName) !== null && _a !== void 0 ? _a : null;
        // TODO: should validate type? should coarse value to type?
        this.type = (_b = (columnObj.ColumnType || columnObj.DateType)) !== null && _b !== void 0 ? _b : null;
        this.ordinal = ordinal;
    }
}
exports.KustoResultColumn = KustoResultColumn;
class KustoResultTable {
    constructor(tableObj) {
        this.name = tableObj.TableName;
        if (tableObj.TableId !== undefined) {
            this.id = tableObj.TableId;
        }
        if (tableObj.TableKind) {
            this.kind = tableObj.TableKind;
        }
        this.columns = tableObj.Columns.map((item, index) => new KustoResultColumn(item, index));
        this._rows = tableObj.Rows;
        if (this._rows && this._rows.length > 0) {
            for (let i = 0; i < tableObj.Rows.length; i++) {
                Object.defineProperty(this, i, { get: () => new KustoResultRow(this.columns, this._rows[i]) });
            }
        }
    }
    *rows() {
        for (const row of this._rows) {
            yield new KustoResultRow(this.columns, row);
        }
    }
    toJson() {
        const table = {};
        table.name = this.name;
        table.data = [];
        for (const row of this.rows()) {
            table.data.push(row.toJson());
        }
        return table;
    }
    toString() {
        return JSON.stringify(this.toJson());
    }
}
exports.KustoResultTable = KustoResultTable;
//# sourceMappingURL=models.js.map